import React from 'react';
import {FormModal} from 'components/modals';
import ChannelEvaluationsTasksForm from './ChannelEvaluationsTasksForm';
import i18n from 'i18n';

interface ChannelEvaluationsTasksModalProps {
    isOpen: boolean;
    onClose: () => void;
    activeEvaluationId: number;
    activeChannelId: number;
}

const ChannelEvaluationsTasksModal: React.FC<ChannelEvaluationsTasksModalProps> = React.memo((
    {
        isOpen,
        onClose,
        activeEvaluationId,
        activeChannelId,
    },
) => {

    return (
        <FormModal
            isOpen={isOpen}
            onClose={onClose}
            title={i18n.t('jt_evaluation_task_settings.text')}
        >
            <ChannelEvaluationsTasksForm
                objId={activeEvaluationId}
                activeChannelId={activeChannelId}
                onSave={onClose}
            />
        </FormModal>
    );
});

export default ChannelEvaluationsTasksModal; 